import QuestionIcon from "@/assets/common/ic_question.svg";
import CloseIcon from "@/assets/common/ic_modal_close.svg?react";
import ArrowLeftIcon from "@/assets/common/ic_modal_arrow_left.svg?react";
import summarySrcStore from "@/store/summarySrc.store";
import fridayReporter from "@/utils/friday";
import Switch from "@/component/Switch";
import { Tooltip } from "antd";
import LinkValidPeriodSelect from "./LinkValidPeriodSelect";
import { LinkValidPeriodType } from "@/constants/share";
import { IShareSettingAttr, IPartialShareSettingAttr } from "@/types/share";

interface SettingPanelProps {
  shareSetting: IShareSettingAttr;
  expiredTime?: Date;
  onClose: () => void;
  onBack: () => void;
  onShareSettingChange: (params: IPartialShareSettingAttr) => void;
}

const SettingPanel = ({
  shareSetting,
  expiredTime,
  onClose,
  onBack,
  onShareSettingChange,
}: SettingPanelProps) => {
  const onLinkValidPeriodChange = (newLinkValidPeriod: LinkValidPeriodType) => {
    onShareSettingChange({
      linkValidity: newLinkValidPeriod,
    });
  };

  const onAllowBackUpChange = (checked: boolean) => {
    onShareSettingChange({
      allowBackUp: checked,
    });

    // 修改是否允许创建副本
    const { detailInfo } = summarySrcStore.getState();
    if (detailInfo) {
      summarySrcStore.getState().setDetailInfo({
        ...detailInfo,
        allowBackUp: checked,
      });
    }

    if (checked) {
      fridayReporter.pushData({
        eventCode: "SummaryPage_Share_AllowCreatCopy",
      });
    }
  };

  const onAllowExportChange = (checked: boolean) => {
    onShareSettingChange({
      allowExport: checked,
    });
    const { detailInfo } = summarySrcStore.getState();
    if (detailInfo) {
      summarySrcStore.getState().setDetailInfo({
        ...detailInfo,
        allowExport: checked,
      });
    }
  };
  const onWaterMarkEnableChange = (checked: boolean) => {
    onShareSettingChange({
      waterMarkEnable: checked,
    });
  };

  return (
    <div className="mx-4">
      <div className="flex items-center h-12 w-full">
        <div className="flex items-center">
          <ArrowLeftIcon className="cursor-pointer" onClick={onBack} />
          <div className="text-4 font-500 text-mx-secondary">安全设置</div>
        </div>
        <CloseIcon
          className="block absolute right-3 top-3 size-6 cursor-pointer"
          onClick={onClose}
        />
      </div>
      <div className="mt-2 mb-8">
        <div className="text-3 text-mx-tertiary lh-6 mb-1">链接有效期</div>
        <LinkValidPeriodSelect
          expiredTime={expiredTime}
          linkValidPeriod={shareSetting.linkValidity as LinkValidPeriodType}
          setLinkValidPeriod={onLinkValidPeriodChange}
        />
      </div>
      <div className="mb-8">
        <div className="text-3 text-mx-tertiary lh-6 mb-1">操作权限</div>
        <div className="flex items-center justify-between h-10">
          <div className="flex items-center">
            <span className="text-3.5">是否允许成员创建副本</span>
            <Tooltip
              title={
                <div className="w-40 font-400 text-3">
                  被分享人可对当前会记创建副本，并对副本进行编辑操作
                </div>
              }
            >
              <img className="size-5 ml-2" src={QuestionIcon} />
            </Tooltip>
          </div>
          <Switch
            className="ml-2 setting-switch"
            checked={shareSetting.allowBackUp}
            size="small"
            onChange={onAllowBackUpChange}
          />
        </div>
        <div className="flex items-center justify-between h-10">
          <span className="text-3.5">是否允许成员导出</span>
          <Switch
            checked={shareSetting.allowExport}
            size="small"
            onChange={onAllowExportChange}
          />
        </div>
      </div>
      <div className="mb-8">
        <div className="text-3 text-mx-tertiary lh-6 mb-1">安全</div>
        <div className="flex items-center justify-between h-10">
          <span className="text-3.5">导出文件是否带水印</span>
          <Switch
            checked={shareSetting.waterMarkEnable}
            size="small"
            onChange={onWaterMarkEnableChange}
          />
        </div>
      </div>
    </div>
  );
};

export default SettingPanel;
